/**
 * The base service
 */
export class BaseService {}
